import { render, staticRenderFns } from "./bankCardList.vue?vue&type=template&id=4be51289"
import script from "./bankCardList.vue?vue&type=script&lang=js"
export * from "./bankCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports